<template>
  <div class="courseTop" v-if="info">
    <div class="titleBox">
      <div class="titleContent">
        <div class="info">
          <p class="name ">{{ info.name}}</p>
          <p class="title ellipsis">{{ info.subtitle }}</p>
        </div>
        <p
          class="count"
          v-if="courseType==1003"
        >
          <span>共{{ info.coursecount }}门课</span><i></i>
          <span>共{{ info.videocount }}讲</span><i></i>
          <span>{{ util.showCount(info.watchcout) }}人学过</span>
        </p>
        <p
          class="count"
          v-else
        >
          <span>已更新{{ info.publishlessonnum||0 }}讲</span><i></i>
          <span>共{{ info.lessoncount }}讲</span><i></i>
          <span>{{ util.showCount(info.watchcout) }}人学过</span>
        </p>
      </div>
    </div>
    <div
      class="tipBox"
      v-if="(courseType == 1001 || courseType == 1002)&&info.customercourse!='Y'"
    >
      <div class="tipTop">
        <span class="label">{{
          courseType == 1002 ? dataInfo.groupnum + "人拼团" : "限时特惠"
        }}</span>
        <span
          class="tip"
          v-html="showTip()"
        ></span>
        <!-- {{showTip()}} -->
      </div>
      <div class="tipContent">
        <!-- <div class="price ellipsis">
          <span class="new">¥{{
              courseType == 1001 ? dataInfo.flashsaleprice : dataInfo.groupprice
            }}</span><span class="old"><s>¥{{ dataInfo.sellingprice }}</s></span>
        </div> -->
        <div class="countTime">
          <span>{{ hours }}</span><em>:</em> <span>{{ minutes }}</span><em>:</em><span>{{ seconds }}</span>
        </div>
      </div>
    </div>
    <div
      class="price"
      v-if="(courseType==1000||courseType==1003)"
    >
      <div class="sellingprice"><em>¥</em><span>{{sellingprice}}</span></div>
      <div
        class="marketprice"
        v-if="marketprice>sellingprice"
      ><s><em>¥</em><span>{{marketprice}}</span></s> </div>
    </div>
    <div
      class="discount"
      v-if="coupons.length>0&&info.customercourse!='Y'"
    >
      <div class="opation">
        <span>优惠</span>
        <span
          class="receive"
          @click="receive()"
        >立即领取</span>
      </div>
      <div class="discountList ellipsis">
        <span
          v-for="(item, index) in coupons"
          :key="index"
        >
          {{ (index != 0 ? " · " : "") + item.title }}
        </span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ["courseType", "info", "dataInfo", "systemtime"],
  data() {
    return {
      hours: "",
      minutes: "",
      seconds: "",
      coupons: [],
      sellingprice: "-1",
      marketprice: "-1",
    };
  },
  watch: {
    ["systemtime"]() {
      this.countdown(this.systemtime, this.systemtime > this.dataInfo.startdate ? this.dataInfo.enddate : this.dataInfo.startdate);
    },
    ['info']() {
      this.getCoupons();
      if (this.courseType == "1003") {
        this.sellingprice = this.info.packageprices[0].sellingprice;
        this.marketprice = this.info.packageprices[0].marketprice;
      } else {
        this.sellingprice = this.info.coursepricedtoes[0].sellingprice;
        this.marketprice = this.info.coursepricedtoes[0].marketprice;
      }
    },
  },
  components: {
  },
  created() { },
  mounted() {
  },
  methods: {
    showTip() {
      var text = '';
      switch (this.courseType - 0) {
        case 1002:
          text = '距离优惠结束';
          break;
        case 1001:
          text = this.systemtime > this.dataInfo.startdate && this.systemtime < this.dataInfo.enddate ? '距离优惠结束' : '距离优惠开始'
          break;
        default:
          break;
      }
      return text;
    },

    countdown(startTime, endTime) {
      var time = endTime - startTime;
      var days = parseInt(time / (1000 * 60 * 60 * 24));
      var hours = parseInt(time / (1000 * 60 * 60));
      var minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = parseInt((time % (1000 * 60)) / 1000);
      this.hours = hours >= 10 ? hours : "0" + hours;
      this.seconds = seconds >= 10 ? seconds : "0" + seconds;
      this.minutes = minutes >= 10 ? minutes : "0" + minutes;
    },
    getCoupons() {
      var productid = this.courseType == 1003 ? this.info.packageprices[0].productid : this.info.coursepricedtoes[0].productid;
      var obj = {
        products: [{ productid: productid, quantity: 1 }],
      };
      this.$post("/iart-api-crm/api/crm/custservice/queryPromotion", obj).then(
        (res) => {
          if (res.code == 1) {
            this.coupons = res.data ? res.data : [];
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    receive() {
      this.$emit('courseTopCallback', { type: 'receive', list: this.coupons })
    },
  },
};
</script>

<style lang="scss" scoped>
.courseTop {
  .titleBox {
    .titleContent {
      width: 90vw;
      padding: 24px 16px;
      background: url(../../../../assets/img/h5/courseBg.png) no-repeat;
      background-size: 100% 100%;
      .info {
        .name {
          font-size: 22px;
          line-height: 30px;
          color: rgba(51, 54, 51, 1);
          font-weight: bold;
          max-height: 60px;
          overflow: hidden;
        }
        .title {
          font-size: 13px;
          line-height: 18px;
          color: rgba(51, 51, 51, 1);
          margin-top: 4px;
        }
        padding-bottom: 16px;
        border-bottom: 0.5px dashed rgba(53, 54, 60, 1);
      }
      .count {
        margin-top: 16px;
        font-size: 12px;
        line-height: 17px;
        color: rgba(45, 45, 45, 0.6);
        font-weight: 400;
        i {
          display: inline-block;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          margin: 0 10px;
          vertical-align: middle;
          background: rgba(120, 110, 118, 1);
        }
        span {
          vertical-align: middle;
        }
      }
    }
  }
  .tipBox {
    margin: 24px 16px 0;
    background: rgba(201, 55, 61, 1);
    border-radius: 4px;
    padding: 12px 16px;
    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    .tipTop {
      .label {
        display: inline-block;
        font-size: 11px;
        line-height: 16px;
        color: rgba(201, 55, 61, 1);
        padding: 3px 6px;
        background: rgba(244, 211, 153, 1);
        border-radius: 3px;
      }
      .tip {
        font-size: 11px;
        line-height: 16px;
        color: rgba(255, 255, 255, 1);
        font-weight: 500;
      }
    }
    .tipContent {
      margin-top: 2px;
      .price {
        flex: 1;
        margin-right: 12px;
        span {
          vertical-align: middle;
        }
        .new {
          font-size: 22px;
          line-height: 28px;
          color: rgba(255, 255, 255, 1);
          font-weight: bolder;
        }
        .old {
          font-size: 12px;
          line-height: 15px;
          color: rgba(255, 255, 255, 0.6);
          margin-left: 8px;
        }
      }
      .countTime {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        span {
          display: inline-block;
          width: 28px;
          height: 30px;
          font-size: 14px;
          line-height: 30px;
          color: rgba(201, 55, 61, 1);
          font-weight: bolder;
          text-align: center;
          border-radius: 3px;
          background: #fff;
          overflow: hidden;
        }
        em {
          font-size: 14px;
          line-height: 30px;
          color: rgba(255, 255, 255, 1);
          margin: 0 6px;
        }
      }
    }
  }
  .price {
    margin: 16px;
    div {
      display: inline-block;
    }
    .sellingprice {
      font-size: 24px;
      line-height: 31px;
      font-weight: bolder;
      color: rgba(53, 54, 60, 1);
      em {
        font-size: 11px;
        line-height: 16px;
        margin-right: 4px;
      }
    }
    .marketprice {
      margin-left: 6px;
      font-size: 11px;
      line-height: 16px;
      color: rgba(134, 135, 138, 1);
      em {
        margin-right: 4px;
      }
    }
  }
  .discount {
    background: rgba(201, 103, 55, 0.05);
    border-radius: 3px;
    padding: 18px 16px;
    margin: 16px 16px 0;
    .opation {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 14px;
        line-height: 20px;
        color: rgba(53, 54, 60, 1);
        font-weight: 600;
      }
      .receive {
        font-size: 12px;
        line-height: 17px;
        color: rgba(201, 55, 61, 1);
      }
    }
    .discountList {
      margin-top: 8px;
      color: rgba(53, 54, 60, 0.4);
      span {
        font-size: 12px;
        line-height: 17px;
        color: rgba(53, 54, 60, 0.4);
        font-weight: 400;
      }
    }
  }
}
</style>